/* global swal angular */
import './style.less';

export default function($log, $timeout, $state, $stateParams, Upload, ProfileClass, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.reviewOnly = false;
  vm.formData = {};

  vm.fileToUpload = false;

  vm.s3Policy = file => {
    return ApiClass.companiesIdTypePut(
      { manage: true, id: company_id, type: 'policies' },
      {
        policy: 'course',
        course_id: $stateParams.courseId,
        file_type: file.type,
        file_name: file.name
      }
    );
  };

  vm.uploadMisc = file => {
    if (!file) return;
    vm.laddaUploadBtn = true;
    vm.s3Policy(file)
      .then(({ data: { item: s3Policy } }) => {
        return Upload.upload({
          url: s3Policy.filePolicy.action,
          data: s3Policy.filePolicy.fields,
          file: file,
          method: 'POST',
          skipAuthorization: true
        }).then(
          () => {
            vm.formData.fileStatus = 'Uploading';
            const eventMaterial = {
              course_id: vm.course.course_id,
              fileUrls: [
                ...vm.formData.fileUrls,
                { name: file.name, url: s3Policy.link, updatedAt: new Date().getTime(), type: 'course' }
              ]
            };
            return ApiClass.coursesIdTypePut(
              { id: vm.course.course_id, type: 'materials' },
              { eventMaterial },
              { queryParams: { manage: true } }
            )
              .then(() => {
                vm.fileToUpload = false;
                vm.formData.fileStatus = '';
                vm.formData.fileUrls.push({
                  url: s3Policy.link,
                  updatedAt: new Date().getTime(),
                  name: file.name
                });
                vm.laddaUploadBtn = false;
              })
              .catch(error => {
                vm.laddaUploadBtn = false;
                $log.error(error);
                throw error;
              });
          },
          error => {
            vm.formData.fileStatus = 'Error - Retry';
            $log.error(error);
            throw error;
          },
          evt => {
            const percent = parseInt((100.0 * evt.loaded) / evt.total) || 0;
            vm.formData.fileStatus = `${percent}%`;
          }
        );
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.removeFile = index => {
    vm.laddaRemoveBtn = true;
    if (!vm.formData.fileUrls || vm.formData.fileUrls.length === 1) vm.formData.fileUrls = [];
    else vm.formData.fileUrls.splice(index, 1);

    const eventMaterial = {
      course_id: vm.course.course_id,
      fileUrls: [...vm.formData.fileUrls]
    };

    return ApiClass.coursesIdTypePut(
      { id: vm.course.course_id, type: 'materials' },
      { eventMaterial },
      { queryParams: { manage: true } }
    )
      .then(() => {
        vm.laddaRemoveBtn = false;
      })
      .catch(error => {
        vm.laddaRemoveBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    try {
      vm.course = vm.ngModel;
      vm.loaded = true;
      vm.error = {};

      if ($state.current.name === 'app.author.courses.course.edit' && vm.ngModel.adminReview) {
        $timeout(() => angular.element('.note-editable').attr('contenteditable', false), 0);
        vm.reviewOnly = true;
      }

      vm.formData = vm.material || {};
      if (vm.formData.fileUrls === undefined) vm.formData.fileUrls = [];

      vm.laaded = true;
    } catch (error) {
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
      $log.error(error);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/author/materials/controller.js